<section fxLayout="column" fxFlex>
  <vdw-header [title]="getTitle() | bmsTranslate" svgIcon="select-blue" [canShowClose]="true"></vdw-header>
  <article class="dialog-content flex-column flex-1 gap-16">
    <ng-container *ngIf="!isSelectingSpecificVersion">
      <button mat-icon-button class="mat-icon-action-button-lg-with-border" [matTooltip]="'GENERAL.ACTIONS.CREATE_NEW' | bmsTranslate" (click)="navigateToAddProductConfiguration()">
        <mat-icon svgIcon="add"></mat-icon>
      </button>
      <ag-grid-angular #productConfigurationsGrid class="ag-theme-vdw" [gridOptions]="gridOptionsForProductConfiguration" [rowData]="listOfProductConfigurations"></ag-grid-angular>
    </ng-container>
    <ag-grid-angular
      #productConfigurationVersionsHistoryGrid
      class="ag-theme-vdw"
      *ngIf="isSelectingSpecificVersion"
      [gridOptions]="gridOptionsForProductConfigurationVersionHistory"
      [rowData]="selectedProductConfiguration?.versionHistories"
    ></ag-grid-angular>
  </article>
  <vdw-footer
    *ngIf="isSelectingSpecificVersion"
    cancelEventName="GENERAL.NAVIGATION.BACK"
    [centered]="true"
    [locked]="!selectedProductConfiguration"
    (chooseEvent)="selectProductConfiguration()"
    (cancelEvent)="cancelSpecificVersionSelection()"
  ></vdw-footer>

  <vdw-footer *ngIf="!isSelectingSpecificVersion" [centered]="true" [locked]="!selectedProductConfiguration" (chooseEvent)="selectProductConfiguration()">
    <button mat-stroked-button (click)="selectSpecificVersion()" [disabled]="!selectedProductConfiguration">
      {{ 'GENERAL.ACTIONS.SELECT_OBJECT' | bmsTranslate: {object: 'PRODUCTION_ORDER.SELECT_PRODUCT_CONFIGURATION.SPECIFIC_VERSION' | bmsTranslate | lowercase} }}
    </button>
  </vdw-footer>
</section>
